/* jshint esversion: 6 */

// CSS styles for keyboard navigation are in app/forms/custom-select.css
// (imported via HTML/SCSS pipeline, not directly in JS)

const formatLabel = function (string = '', prepend = '', expression = undefined) {
  const splitted = string.split(',');
  if (splitted.length > 1) {
    let formatted = splitted.shift();
    splitted.forEach((value, index) => {
      if (expression) {
        formatted = formatted.split('{' + index + '}').join('\' + ' + prepend + value + ' + \'');
      } else {
        formatted = formatted.split('{' + index + '}').join(prepend + value);
      }
    });
    if (expression) {
      return '\'' + formatted + '\'';
    } else {
      return formatted;
    }
  } else {
    return prepend + string;
  }
};

let uniqueId = 0;

let errorElements = [],
  to;

export default class ControlDirective {

  constructor(
    $parse,
    DomService
  ) {
    this.$parse = $parse;
    this.domService = DomService;
    this.restrict = 'A';
    this.templateUrl = (element, attributes) => {
      var template = 'templates/forms/text.html';
      switch (attributes.control) {
        case 'checkbox':
          template = 'templates/forms/checkbox.html';
          break;
        case 'password':
          template = 'templates/forms/password.html';
          break;
        case 'select':
          template = 'templates/forms/select.html';
          break;
        case 'custom-select':
          template = 'templates/forms/custom-select.html';
          break;
        case 'autocomplete':
          template = 'templates/forms/autocomplete.html';
          break;
        case 'autocomplete-single-option':
          template = 'templates/forms/autocomplete-single-option.html';
          break;
        case 'textarea':
          template = 'templates/forms/textarea.html';
          break;
        case 'textlocked':
          template = 'templates/forms/textlocked.html';
          break;
      }
      return template;
    };
    this.scope = {
      ngModel: '=',
      required: '=',
      form: '@',
      title: '@',
      placeholder: '@',
      source: '=?',
      key: '@?',
      label: '@?',
    };
    this.require = 'ngModel';
    this.transclude = true;
    this.link = {
      pre: (scope, element, attributes, controller, transclude) => {
        this.linkMethod(scope, element, attributes, controller, transclude);
      }
    };

  }

  linkMethod(scope, element, attributes, controller, transclude) {
    const label = scope.label = (scope.label ? scope.label : 'name');
    const key = scope.key = (scope.key ? scope.key : 'id');
    if (attributes.control === 'select') {
      const filter = (attributes.filter ? '| ' + attributes.filter : '');
      const optionLabel = formatLabel(label, 'item.', true);
      scope.getOptions = () => {
        return attributes.number ?
          'item.' + key + ' as ' + optionLabel + ' disable when item.disabled for item in source ' + filter :
          optionLabel + ' disable when item.disabled for item in source ' + filter + ' track by item.' + key;
      };
    }
    if (attributes.autofocus !== undefined) {
      const input = element[0].querySelector('input');
      if (input) {
        input.setAttribute('autofocus', true);
        setTimeout(function () {
          input.focus();
        }, 500);
      }
    }
    const type = scope.type = attributes.control;
    const form = scope.form = scope.form || 'form';
    const title = scope.title = scope.title || 'untitled';
    const placeholder = scope.placeholder = scope.placeholder || title;
    const field = scope.field = title.replace(/[^0-9a-zA-Z]/g, "").split(' ').join('') + (++uniqueId);
    scope.format = attributes.format || null;
    scope.precision = attributes.precision || null;
    scope.validate = attributes.validate || attributes.control;
    scope.minLength = attributes.minLength || 0;
    scope.maxLength = attributes.maxLength || Number.POSITIVE_INFINITY;
    scope.min = attributes.min || null;
    scope.max = attributes.max || null;
    scope.options = this.$parse(attributes.options)(scope) || {};
    scope.focus = false;
    scope.visible = false;
    scope.updateView = (value) => {
      controller.$viewValue = value;
      controller.$render();
    }
    scope.updateModel = (value) => {
      controller.$setViewValue(value);
      // controller.$modelValue = value;
      scope.ngModel = value; // overwrites ngModel value
    }
    scope.optionName = (id) => {
      if (id) {
        const option = scope.source.find(x => x.id === id);
        if (option) {
          return option.name;
        }
      }
      if (Array.isArray(scope.ngModel)) {
        return scope.ngModel.map(x => scope.source.find(s => s.id === x).name).join(', ');
      } else {
        const option = scope.source.find(x => x.id === scope.ngModel);
        if (option) {
          return option.name;
        }
      }
    }
    scope.onModelAdd = (value) => {
      const items = controller.$viewValue || [];
      const index = items.indexOf(value);
      if (index === -1) {
        items.push(value);
        controller.$setViewValue(items);
        // console.log(controller);
        scope.ngModel = items; // overwrites ngModel value
      }
      scope.query = null;
    };
    scope.onModelRemove = (value) => {
      const items = controller.$viewValue || [];
      const index = items.indexOf(value);
      if (index !== -1) {
        items.splice(index, 1);
        controller.$setViewValue(items);
        scope.ngModel = items; // overwrites ngModel value
      }
      scope.query = null;
    };
    scope.searchQuery = () => {
      return function (item) {
        // console.log(item, scope.query);
        if (scope.query) {
          return item.name.toLowerCase().indexOf(scope.query.toLowerCase()) !== -1;
        } else {
          return true;
        }
      };
    };
    scope.modelValue = () => {
      const value = controller.$viewValue || [];
      // console.log(value);
      return value;
    };
    scope.onChange = (model) => {
      // console.log('ControlDirective.onChange');
      this.$parse(attributes.onChange)(scope.$parent);
    };
    scope.onFilter = (model) => {
      this.$parse(attributes.onFilter)(scope.$parent);
    };
    scope.getType = () => {
      let type = 'text';
      switch (attributes.control) {
        case 'password':
          type = scope.visible ? 'text' : 'password';
          break;
        case 'textlocked':
          type = 'text';
          break;

        default:
          type = attributes.control;
      }
      return type;
    };
    scope.onFocus = () => {
      scope.focus = true;
      // console.log('ControlDirective.onFocus', scope.focus);
    };
    scope.onBlur = () => {
      scope.focus = false;
      // console.log('ControlDirective.onBlur', scope.focus);
      this.scrollToError();
    };
    scope.getClasses = () => {
      const field = controller; // this.$parse(scope.form + '.' + scope.field)(scope.$parent);
      if (field) {
        const focus = scope.focus;
        const success = field.$valid;
        const form = this.$parse(scope.form)(scope.$parent);
        const error = field.$invalid && (form.$submitted || field.$touched);
        const empty = !field.$viewValue;
        if (error) {
          this.onError(element);
          if (scope.error !== error) {
            scope.error = error;
            this.scrollToError();
          }
        } else {
          scope.error = false;
        }
        return { focus, success, error, empty };
      }
    };
    scope.getMessages = () => {
      const form = this.$parse(scope.form)(scope.$parent);
      const field = this.$parse(scope.form + '.' + scope.field)(scope.$parent);
      return (form.$submitted || field.$touched) && field.$error;
    }; scope.toggleVisibility = () => {
      scope.visible = !scope.visible;
    };
    // Add keyboard navigation for custom-select
    scope.dropdownVisible = false;
    scope.highlightedIndex = -1;
    scope.toggleDropdown = () => {
      scope.dropdownVisible = !scope.dropdownVisible;

      if (scope.dropdownVisible) {
        // Open the dropdown
        scope.$root.$broadcast('onDroppedIn', element[0]);

        // Determine which option should be highlighted
        if (scope._openedFromKeyboard || scope.ngModel === null || scope.ngModel === undefined) {
          // Find first non-disabled option
          scope.highlightedIndex = scope.source.findIndex(item => !item.disabled);
        } else {
          // Find currently selected option
          scope.highlightedIndex = scope.source.findIndex(item => item.id === scope.ngModel);
          if (scope.highlightedIndex === -1) {
            // Fallback to first non-disabled option
            scope.highlightedIndex = scope.source.findIndex(item => !item.disabled);
          }
        }
        if (scope.ngModel === null || scope.ngModel === undefined || scope._openedFromKeyboard) {
          // Find first non-disabled option
          scope.highlightedIndex = scope.source.findIndex(item => !item.disabled);
        } else {
          // Find currently selected option
          scope.highlightedIndex = scope.source.findIndex(item => item.id === scope.ngModel);
          // Fallback to first option if selected item not found
          if (scope.highlightedIndex === -1) {
            scope.highlightedIndex = scope.source.findIndex(item => !item.disabled);
          }
        }				// Set focus on the highlighted option with a small delay to ensure DOM is ready
        setTimeout(() => {
          const dropdown = element[0].querySelector('.dropdown');
          if (dropdown) {
            const options = dropdown.querySelectorAll('li:not(.disabled)');
            // Ensure highlightedIndex is valid
            if (scope.highlightedIndex < 0 || scope.highlightedIndex >= options.length) {
              scope.highlightedIndex = 0;
            }

            if (options.length > 0) {
              const optionToFocus = options[scope.highlightedIndex];

              // Make sure the option is visible in the dropdown
              optionToFocus.scrollIntoView({ block: 'nearest' });

              // Apply focus to the option directly if opened from keyboard
              if (scope._openedFromKeyboard) {
                // Focus on the option
                optionToFocus.focus();

                // Apply keyboard-focused class for visual indication
                scope.$apply(() => {
                  // This will trigger the class to be applied through ng-class binding
                });
              }
            }
          }
        }, 50);

        // Call toggleDropdown method on the parent has-dropdown directive (if available)
        const hasDropdownScope = angular.element(element[0].closest('[has-dropdown]')).scope();
        if (hasDropdownScope && typeof hasDropdownScope.toggleDropdown === 'function') {
          hasDropdownScope.toggleDropdown();
        }

        // Reset the keyboard flag after handling
        scope._openedFromKeyboard = false;
      } else {
        // Close the dropdown
        scope.$root.$broadcast('onDroppedOut', element[0]);
        scope.highlightedIndex = -1;

        // Remove any keyboard focus indicators
        const dropdown = element[0].querySelector('.dropdown');
        if (dropdown) {
          const focusedElements = dropdown.querySelectorAll('.keyboard-focused');
          Array.from(focusedElements).forEach(el => el.classList.remove('keyboard-focused'));
        }

        // Call toggleDropdown method on the parent has-dropdown directive (if available)
        const hasDropdownScope = angular.element(element[0].closest('[has-dropdown]')).scope();
        if (hasDropdownScope && typeof hasDropdownScope.toggleDropdown === 'function') {
          hasDropdownScope.toggleDropdown();
        }

        // Return focus to the select control
        const control = element[0].querySelector('.form__control');
        if (control) {
          control.focus();
        }
      }

      // Need to apply changes since we're updating outside of Angular's knowledge
      if (!scope.$root.$$phase) {
        scope.$apply();
      }
    }; scope.selectOption = (itemId, index, event) => {
      // For touch events, prevent the subsequent click event
      if (event && event.type === 'touchend') {
        event.preventDefault();
        event.stopPropagation();
        // Set a flag to prevent duplicate execution from click event
        scope._touchEndHandled = true;
        setTimeout(() => {
          delete scope._touchEndHandled;
        }, 100);
      } else if (event && event.type === 'click' && scope._touchEndHandled) {
        // Skip click event if touchend was already handled
        return;
      }

      scope.updateModel(itemId);
      scope.onChange();
      scope.toggleDropdown();
      // Return focus to the select control
      element[0].querySelector('.form__control').focus();

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    };// Handle keydown events on options in the dropdown
    scope.onOptionKeyDown = (event, itemId, index) => {
      const options = scope.source.filter(item => !item.disabled);

      switch (event.keyCode) {
        case 13: // Enter
        case 32: // Space
          // Select the option and close dropdown
          scope.updateModel(itemId);
          scope.onChange();
          scope.toggleDropdown();
          // Return focus to the select control
          element[0].querySelector('.form__control').focus();
          event.preventDefault();
          event.stopPropagation();
          break;

        case 38: // Arrow Up
          if (index > 0) {
            scope.highlightedIndex = index - 1;
            const prevOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
            if (prevOption) {
              prevOption.focus();
              prevOption.scrollIntoView({ block: 'nearest' });
            }
          } else {
            // Loop to the last item when at the first item
            scope.highlightedIndex = options.length - 1;
            const lastOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
            if (lastOption) {
              lastOption.focus();
              lastOption.scrollIntoView({ block: 'nearest' });
            }
          }
          event.preventDefault();
          event.stopPropagation();
          break;

        case 40: // Arrow Down
          if (index < options.length - 1) {
            scope.highlightedIndex = index + 1;
            const nextOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
            if (nextOption) {
              nextOption.focus();
              nextOption.scrollIntoView({ block: 'nearest' });
            }
          } else {
            // Loop to the first item when at the last item
            scope.highlightedIndex = 0;
            const firstOption = element[0].querySelector('#option-' + field + '-0');
            if (firstOption) {
              firstOption.focus();
              firstOption.scrollIntoView({ block: 'nearest' });
            }
          }
          event.preventDefault();
          event.stopPropagation();
          break;

        case 27: // Escape
          scope.toggleDropdown();
          element[0].querySelector('.form__control').focus();
          event.preventDefault();
          event.stopPropagation();
          break;

        case 9: // Tab
          // Handle tab key to navigate between options
          if (event.shiftKey) {
            // Shift+Tab - move to previous option
            if (index > 0) {
              scope.highlightedIndex = index - 1;
              const prevOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
              if (prevOption) {
                prevOption.focus();
                prevOption.scrollIntoView({ block: 'nearest' });
              }
            } else {
              // Loop to the last item when at the first item
              scope.highlightedIndex = options.length - 1;
              const lastOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
              if (lastOption) {
                lastOption.focus();
                lastOption.scrollIntoView({ block: 'nearest' });
              }
            }
          } else {
            // Regular Tab - move to next option
            if (index < options.length - 1) {
              scope.highlightedIndex = index + 1;
              const nextOption = element[0].querySelector('#option-' + field + '-' + scope.highlightedIndex);
              if (nextOption) {
                nextOption.focus();
                nextOption.scrollIntoView({ block: 'nearest' });
              }
            } else {
              // Loop to the first item when at the last item
              scope.highlightedIndex = 0;
              const firstOption = element[0].querySelector('#option-' + field + '-0');
              if (firstOption) {
                firstOption.focus();
                firstOption.scrollIntoView({ block: 'nearest' });
              }
            }
          }
          event.preventDefault();
          event.stopPropagation();
          break;
      }

      // Apply changes to update the UI
      if (!scope.$root.$$phase) {
        scope.$apply();
      }
    };

    scope.onKeyDown = (event) => {
      // Check if this is a regular select or custom-select
      const isCustomSelect = attributes.control === 'custom-select';
      const dropdown = isCustomSelect ? element[0].querySelector('.dropdown') : null;
      const options = scope.source ? scope.source.filter(item => !item.disabled) : [];

      // Handle keyboard navigation differently based on select type
      if (isCustomSelect) {
        // Custom select keyboard handling
        switch (event.keyCode) {
          case 13: // Enter
          case 32: // Space
            if (scope.dropdownVisible) {
              if (scope.highlightedIndex >= 0 && scope.highlightedIndex < options.length) {
                scope.updateModel(options[scope.highlightedIndex].id);
                scope.onChange();
                scope.toggleDropdown();
              }
            } else {
              // Flag that we're opening from keyboard to properly set focus on first option
              scope._openedFromKeyboard = true;

              // Toggling dropdown when Enter is pressed, just like when clicking with the mouse
              scope.toggleDropdown();

              // Ensure focus moves to the first option in the dropdown
              setTimeout(() => {
                const dropdown = element[0].querySelector('.dropdown');
                if (dropdown) {
                  const firstOption = dropdown.querySelector('li:not(.disabled)');
                  if (firstOption) {
                    firstOption.focus();
                  }
                }
              }, 100);

              // Force digest cycle to update the UI immediately
              if (!scope.$root.$$phase) {
                scope.$apply();
              }
            }
            event.preventDefault();
            break;

          case 27: // Escape
            if (scope.dropdownVisible) {
              scope.toggleDropdown();
              event.preventDefault();
            }
            break;

          case 38: // Arrow Up
            if (scope.dropdownVisible) {
              if (scope.highlightedIndex <= 0) {
                scope.highlightedIndex = options.length - 1;
              } else {
                scope.highlightedIndex--;
              }

              // Ensure highlighted item is visible
              setTimeout(() => {
                const highlighted = dropdown.querySelector(`li:nth-child(${scope.highlightedIndex + 1})`);
                if (highlighted) {
                  highlighted.scrollIntoView({ block: 'nearest' });
                }
              }, 0);

              event.preventDefault();

              // Apply changes
              if (!scope.$root.$$phase) {
                scope.$apply();
              }
            }
            break;

          case 40: // Arrow Down
            if (scope.dropdownVisible) {
              if (scope.highlightedIndex >= options.length - 1) {
                scope.highlightedIndex = 0;
              } else {
                scope.highlightedIndex++;
              }

              // Ensure highlighted item is visible
              setTimeout(() => {
                const highlighted = dropdown.querySelector(`li:nth-child(${scope.highlightedIndex + 1})`);
                if (highlighted) {
                  highlighted.scrollIntoView({ block: 'nearest' });
                }
              }, 0);

              event.preventDefault();

              // Apply changes
              if (!scope.$root.$$phase) {
                scope.$apply();
              }
            } else {
              scope.toggleDropdown();
              event.preventDefault();
            }
            break; case 9: // Tab
            if (scope.dropdownVisible) {
              // When dropdown is open, and Tab is pressed on the main control,
              // focus the first option instead of closing the dropdown
              event.preventDefault(); // Prevent default tab behavior

              // Focus on the first non-disabled option
              const firstOption = element[0].querySelector('li:not(.disabled)');
              if (firstOption) {
                scope.highlightedIndex = parseInt(firstOption.getAttribute('id').split('-').pop(), 10);
                firstOption.focus();
                firstOption.scrollIntoView({ block: 'nearest' });

                // Apply changes
                if (!scope.$root.$$phase) {
                  scope.$apply();
                }
              }
            }
            // If dropdown is not visible, allow default tab behavior
            break;

          default:
            // Handle first-letter navigation
            if (scope.dropdownVisible && event.key && event.key.length === 1) {
              const char = event.key.toLowerCase();
              for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (option.name && option.name.toLowerCase().startsWith(char)) {
                  scope.highlightedIndex = i;

                  setTimeout(() => {
                    const highlighted = dropdown.querySelector(`li:nth-child(${i + 1})`);
                    if (highlighted) {
                      highlighted.scrollIntoView({ block: 'nearest' });
                    }
                  }, 0);

                  // Apply changes
                  if (!scope.$root.$$phase) {
                    scope.$apply();
                  }

                  break;
                }
              }
            }
            break;
        }
      } else if (attributes.control === 'select') {
        // Regular select keyboard handling - most of it is handled natively by the browser,
        // but we need to ensure focus state and other behaviors are consistent
        switch (event.keyCode) {
          case 13: // Enter
            // Just ensure change event fires as expected
            scope.onChange();
            break;

          case 32: // Space
            // For native selects, space usually toggles the dropdown
            // Let the browser handle the default behavior
            break;

          case 38: // Arrow Up
          case 40: // Arrow Down
            // Let the browser handle the default navigation behavior
            // but update the focus state
            scope.focus = true;
            if (!scope.$root.$$phase) {
              scope.$apply();
            }
            break;
        }
      }
    };

    scope.$on('onInvalid', () => {
      this.scrollToError();
    });
  }

  onError(element) {
    if (errorElements.indexOf(element) === -1) {
      errorElements.push(element);
    }
  }

  scrollToError() {
    if (errorElements.length) {
      if (to) {
        clearTimeout(to);
      }
      to = setTimeout(() => {
        const top = errorElements.reduce((previous, current, index, array) => {
          const node = current[0];
          return Math.min(previous, node.getBoundingClientRect().top);
        }, Number.POSITIVE_INFINITY);
        window.scrollTo(0, (document.body.scrollTop || document.documentElement.scrollTop) + top - 10);
        /*
        window.scroll({
          top: (document.body.scrollTop || document.documentElement.scrollTop) + top - 10,
          left: 0,
          behavior: 'smooth'
        });
        */
        errorElements = [];
      }, 100);
    }
  }

  link(scope, element, attributes, controller) { }

  static factory($parse, DomService) {
    return new ControlDirective($parse, DomService);
  }

}

ControlDirective.factory.$inject = ['$parse', 'DomService'];
